import BaseModel from './BaseModel'

export default class RoService extends BaseModel {
  // ... RoService-specific methods or overrides ...
}
